import { ALL_WEEKDAYS, MONTHS } from '@constants';
import { dateProvider } from '@utils';
import type { TFunction } from 'i18next';

export const formatScheduledDate = (
  date: Date,
  tDefault: TFunction<'DefaultTranslations'>
): string => {
  const dayOfWeek = date.getDay();
  const weekdayKeys = ALL_WEEKDAYS;

  const month = date.getMonth();

  const correctedIndex = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
  const dayName = tDefault(weekdayKeys[correctedIndex]);
  const monthName = tDefault(MONTHS[month]);
  const dayNumber = date.getDate();
  const time = dateProvider.format(date, 'h:mm a');

  const abbreviatedMonth = monthName.slice(0, 3);

  return tDefault('SCHEDULED_DATE_FORMAT', {
    dayName,
    dayNumber,
    month: abbreviatedMonth,
    time
  });
};
